import { Injectable } from '@angular/core';
import { ApiService, UserService } from '../..';
@Injectable()
export class BaocaoxuchisochotthangService {
  constructor(public api: ApiService,public user: UserService) {
  }
  APIURL_Chung = "api/ExcuteOracle"
  //Lấy báo cáo thống kê
  public P_LaybaocaoCSCthang(mataikhoan, danhmucid, ngay, type, sotrang, sodong) {
    var param = {
      config: JSON.stringify({ namesql: "PKB_BC_CSC_LOADPROFILE.P_LAY_BC_CSC_THANG" }),
      para: JSON.stringify({
        v_mataikhoan: mataikhoan,
        v_danhmucid: danhmucid,
        v_Date: ngay,
        v_Type: type,
        v_sotrang: sotrang,
        v_sodong: sodong
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }  
  LaybaocaoCSCthang_EXCEL(mataikhoan, danhmucid, ngay, type, sotrang, sodong, tenDanhmuc, filename, thang) {
    let cols = [];
    cols = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "tennhamay", "label": "Tên nhà máy", "horizontalalignment": "left" },
      { "name": "tenkhachhang", "label": "Tên điểm đo", "horizontalalignment": "left" },
      { "name": "socongto", "label": "ID công tơ", "horizontalalignment": "left" },
      { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
      { "name": "hsn", "label": "Hệ số nhân", "horizontalalignment": "right" },
      { "name": "hstt", "label": "Hệ số tổn thất DZ", "horizontalalignment": "right" },
      { "name": "status", "label": "Tình trạng", "horizontalalignment": "left" },
      { "name": "tong", "label": "Tổng điểm đo", "horizontalalignment": "center" },
      { "name": "sl_dd_co", "label": "Số điểm đo có chu kỳ chốt", "horizontalalignment": "center" },
      { "name": "sl_dd_khong", "label": "Số điểm đo không có chu kỳ chốt", "horizontalalignment": "center" },
    ]

    //let curUs = this.user.getCurrentUser();
    var title2 = "BÁO CÁO TỔNG THU THẬP CHỈ SỐ CHỐT THÁNG " + thang;
    var header2 = tenDanhmuc+" - Tháng: " + thang;
    var filename1 = filename;
    var sheets2 = title2
    var cols2 = cols
    var param = {
      config: JSON.stringify({ namesql: "PKB_BC_CSC_LOADPROFILE.P_LAY_BC_CSC_THANG" }),
      para: JSON.stringify({
        v_mataikhoan: mataikhoan,
        v_danhmucid: danhmucid,
        v_Date: ngay,
        v_Type: type,
        v_sotrang: sotrang,
        v_sodong: sodong
      }),
      title: title2 + ',' + "THÔNG TIN CHI TIẾT ĐIỂM ĐO",
      header: tenDanhmuc+" - Tháng: " + thang + ',' + header2,
      filename: filename,
      sheets: sheets2 + ',' + "THÔNG TIN CHI TIẾT ĐIỂM ĐO" ,
      columns: cols,
      data: ""
    };

    return this.api.downloadFile("api/ExportExcel", param, filename);
  }  


  saveExcel(danhmucid, loaihienthi, ngay, gio, loaipha, sotrang, sodong, locdulieu, loaichiso, tendonvi, tenchucnang, noidungbaocao, thoidiemtruyvan) {
    let cols = [];
    if (locdulieu === "0") {
      if (loaipha == "3") {
        cols = [
          { "name": "stt", "label": "STT", "horizontalalignment": "center" },
          { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
          { "name": "loaicongto", "label": "Loại công tơ", "horizontalalignment": "left" },
          { "name": "time", "label": "Thời gian đọc", "horizontalalignment": "center" },
          { "name": "pgiao1", "label": "BT", "horizontalalignment": "right" },
          { "name": "pgiao2", "label": "CD", "horizontalalignment": "right" },
          { "name": "pgiao3", "label": "TD", "horizontalalignment": "right" },
          { "name": "pgiaotong", "label": "SG", "horizontalalignment": "right" },
          { "name": "qgiaotong", "label": "VC", "horizontalalignment": "right" },
          { "name": "hsn", "label": "HSN", "horizontalalignment": "right" },
          { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
          { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
          { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
          { "name": "diachi", "label": "Địa chỉ", "horizontalalignment": "left" },
        ];
      } else {
        cols = [
          { "name": "stt", "label": "STT", "horizontalalignment": "center" },
          { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
          { "name": "loaicongto", "label": "Loại công tơ", "horizontalalignment": "left" },
          { "name": "time", "label": "Thời gian đọc", "horizontalalignment": "center" },
          { "name": "pgiaotong", "label": "KT", "horizontalalignment": "right" },
          { "name": "hsn", "label": "HSN", "horizontalalignment": "right" },
          { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
          { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
          { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
          { "name": "diachi", "label": "Địa chỉ", "horizontalalignment": "left" },
        ];
      }
    }
    else {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
        { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
        { "name": "loaicongto", "label": "Loại công tơ", "horizontalalignment": "left" },
        { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
        { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
        { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
        { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
        { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
        { "name": "marepeater", "label": "Mã repeater", "horizontalalignment": "left" },
      ];
    }
    let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAYDS_CHISOCTO" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_locdulieu: locdulieu,
        v_loaihienthi: loaihienthi,
        v_ngay: ngay,
        v_gio: gio,
        v_loaipha: loaipha,
        v_sotrang: sotrang,
        v_sodong: sodong,
        v_mataikhoan: curUs.mataikhoan,
        v_ip: "",
        v_loaichiso: loaichiso
      }),
      title: tenchucnang + " " + tendonvi,//+ " " + thoidiemtruyvan,
      header: "Ngày: " + thoidiemtruyvan,
      filename: tendonvi + "_" + tenchucnang + ".xlsx",
      sheets: tenchucnang,
      columns: cols,
      data: "",
      danhmucid: danhmucid,
      tenbaocao: "Báo cáo chỉ số công tơ",
      loaibaocao: 1,
      mataikhoan: curUs.mataikhoan
    };
    return this.api.Excute("api/SaveExcel", param);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/bao-cao/bao-cao-chi-so-chot-thang/baocaochisochothang.service.ts